import { useEffect } from 'react';
import { getSocket } from '../lib/socket';
import { playSound } from '../lib/sounds';
import { useChatStore } from '../stores/chat';
import { useAuthStore } from '../stores/auth';
import type { Message, Task } from '../lib/api';

export function useNotificationSounds() {
  const currentUserId = useAuthStore((s) => s.user?.id);

  useEffect(() => {
    if (!currentUserId) return;

    const socket = getSocket();

    function onMessage({ threadId, message }: { threadId: string; message: Message }) {
      if (message.sender_user_id === currentUserId) return;
      if (message.is_system) return;

      const thread = useChatStore.getState().threads.find((t) => t.id === threadId);
      const isClientMsg = thread?.type === 'client' && !message.is_internal;
      playSound(isClientMsg ? 'client' : 'internal');
    }

    function onTaskCreated(task: Task) {
      // Only sound when someone else assigns a task to me
      if (task.assigned_to === currentUserId && task.created_by !== currentUserId) {
        playSound('internal');
      }
    }

    socket.on('message:new', onMessage);
    socket.on('task:created', onTaskCreated);
    return () => {
      socket.off('message:new', onMessage);
      socket.off('task:created', onTaskCreated);
    };
  }, [currentUserId]);
}
